import * as React from "react";
import { SanitisedHtml } from "../html";
import { NBSP } from "../../utils/string";
import { DocumentItem } from "../../model/autogen/DocumentItem";
import { AbstractDocumentKind } from "../../model/autogen/AbstractDocumentKind";
import { renderProfileContents } from "./profile-display";
import { renderMediaLineContents } from "./media-line-display";
import { renderFAQContents } from "./faq-display";
import { renderBriefContents } from "./brief-display";
import { renderPersonContents } from "./person-display";
import { renderDebateContents } from "./debate-notes-display";
// import { renderOpinionEditorialContents } from "./opinion-editorial-display";
import { AbstractDocumentType } from "../../model/autogen/AbstractDocumentType";
import { sortDocumentItems } from "../../utils/document-order";
import Card from "@material-ui/core/Card/Card";
import { Content } from "../content";
import { TagList } from "../utility-components";
import { DocumentModel } from "../../model/autogen/DocumentModel";
import { /*FileAttachmentList,*/ IFileAttachmentCallbacks } from "../file-attachment-list";
import { renderAchievementContents } from "./achievement-display";
/*
import { downloadLinkResolver } from "pages/brief-item-page";
import { AchievementModel } from "model/autogen/AchievementModel";
import { DebateNotesModel } from "model/autogen/DebateNotesModel";
import { FrequentlyAskedQuestionModel } from "model/autogen/FrequentlyAskedQuestionModel";
import { IssueBriefModel } from "model/autogen/IssueBriefModel";
import { MediaLinesModel } from "model/autogen/MediaLinesModel";
import { OpinionEditorialModel } from "model/autogen/OpinionEditorialModel";
import { QuoteModel } from "model/autogen/QuoteModel";
import { ResourceModel } from "model/autogen/ResourceModel";
*/

export const RenderDocumentItemDisplay = (item: DocumentItem) => {
    return <article key={item.guid} style={{ marginBottom: 10 }}>
        {item.inline ? <b>{item.title}{NBSP}</b> : <h3>{item.title}</h3>}
        <SanitisedHtml html={item.content} />
    </article>;
};

function isDocumentModel(item: any): item is DocumentModel {
    return Array.isArray(item.items);
}

function renderContents(sortedItems: DocumentItem[], item: AbstractDocumentType, callbacks: IFileAttachmentCallbacks) {
    switch (item.type) {
        case AbstractDocumentKind.ProfileOfMP:
            return renderProfileContents(sortedItems, item);
        case AbstractDocumentKind.MediaLines:
            return renderMediaLineContents(sortedItems, item);
        case AbstractDocumentKind.FAQ:
            return renderFAQContents(sortedItems, item);
        case AbstractDocumentKind.IssueBrief:
            return renderBriefContents(sortedItems, item);
        case AbstractDocumentKind.Person:
            return renderPersonContents(sortedItems, item);
        case AbstractDocumentKind.Achievement:
            return renderAchievementContents(sortedItems, item);
        case AbstractDocumentKind.DebateNotes:
            return renderDebateContents(sortedItems, item, callbacks);
    }
    return <noscript />;
}

/*
type AttachmentsDocumentType = IssueBriefModel | MediaLinesModel | DebateNotesModel | FrequentlyAskedQuestionModel | OpinionEditorialModel | QuoteModel | AchievementModel | ResourceModel;

function hasAttachments(item: AbstractDocumentType): item is AttachmentsDocumentType {
    switch (item.type) {
        case AbstractDocumentKind.Achievement:
        case AbstractDocumentKind.DebateNotes:
        case AbstractDocumentKind.FAQ:
        case AbstractDocumentKind.IssueBrief:
        case AbstractDocumentKind.MediaLines:
        case AbstractDocumentKind.OpinionEditorial:
        case AbstractDocumentKind.Quote:
        case AbstractDocumentKind.Resource:
            return true;
        default:
            return false;
    }
}
*/

export interface IDocumentDisplayProps extends IFileAttachmentCallbacks {
    item: AbstractDocumentType;
    extraComponents?(): JSX.Element;
    lite?: boolean;
}

export const DocumentDisplay = (props: IDocumentDisplayProps) => {
    const { item, lite, onBeginDeleteFile, onFileDeleted } = props;
    const cb = {
        onBeginDeleteFile,
        onFileDeleted
    };
    const sortedItems = isDocumentModel(item) ? sortDocumentItems(item.items) : [];
    return <>
        {lite === false || lite === undefined && <h2>{item.title}</h2>}
        {lite === false || lite === undefined && <Card>
            <Content>
                <>
                    {renderContents(sortedItems, item, cb)}
                    <TagList tags={item.tags} />
                    {/*hasAttachments(item) && (item.files || []).length > 0 && <FileAttachmentList files={item.files} downloadLinkResolver={downloadLinkResolver} editing={false} />*/}
                    {props.extraComponents && props.extraComponents()}
                </>
            </Content>
        </Card>}
        {lite === true && renderContents(sortedItems, item, cb)}
    </>;
}


// WEBPACK FOOTER //
// ./src/components/display/common.tsx